<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="120px"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.keyword')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.keyword"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
                <el-button @click="getData('search')" type="primary" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="reset" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              v-if="hasCreateAuth"
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="add"
              style="margin-bottom: 10px"
              >{{ $t("button.add") }}
            </el-button>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                v-loading="loading"
                style="width: 100%"
                class="alarmTable"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="ruleCode"
                  :label="$t('alarmPushRule.ruleCode')"
                  min-width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="ruleName"
                  :label="$t('alarmPushRule.ruleName')"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="isPush"
                  :label="$t('alarmPushRule.isPush')"
                  min-width="50"
                >
                  <template slot-scope="scope">
                    <label>{{ scope.row.isPush ? $t("desc.yes") : $t("desc.no") }}</label>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRepeat"
                  :label="$t('alarmPushRule.cycleValue')"
                  min-width="50"
                >
                  <template slot-scope="scope">
                    <label>{{
                      scope.row.cycleValue +
                      (curLanguage == "en" ? " " : "") +
                      $t("alarmPushRule." + scope.row.cycleUnit) +
                      (curLanguage == "en" ? (scope.row.cycleValue > 1 ? "s" : "") : "")
                    }}</label>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="cycleConditionName"
                  :label="$t('alarmPushRule.cycleCondition')"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="isAttachAlarmMsg"
                  :label="$t('alarmPushRule.isAttachAlarmMsg')"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <label>{{
                      scope.row.isAttachAlarmMsg ? $t("desc.yes") : $t("desc.no")
                    }}</label>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('title.operate')" width="150" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      :title="$t('alarmPushRule.ruleDetail')"
                      icon="el-icon-document-copy"
                      circle
                      size="mini"
                      @click="showBindDialog(true, scope.row.id)"
                      v-if="hasUpdateAuth"
                    ></el-button>
                    <el-button
                      v-if="hasUpdateAuth"
                      type="primary"
                      icon="el-icon-edit"
                      :title="$t('button.update')"
                      circle
                      size="mini"
                      @click="edit(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="delUser(scope.row.id)"
                        v-if="hasDeleteAuth"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getData()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog :title="title" :visible.sync="dialog" v-if="dialog" width="60%" top="5vh">
      <el-form :rules="rules" ref="AlarmRform" :model="AlarmRform" label-width="180px">
        <el-row :gutter="24">
          <el-col :xs="24">
            <el-form-item prop="ruleCode" :label="$t('alarmPushRule.ruleCode')">
              <el-input
                type="text"
                v-model="AlarmRform.ruleCode"
                style="max-width: 260px"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item prop="ruleName" :label="$t('alarmPushRule.ruleName')">
              <el-input type="text" v-model="AlarmRform.ruleName" />
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item prop="isPush" :label="$t('alarmPushRule.isPush')">
              <el-radio v-model="AlarmRform.isPush" :label="true">{{
                $t("desc.yes")
              }}</el-radio>
              <el-radio v-model="AlarmRform.isPush" :label="false">{{
                $t("desc.no")
              }}</el-radio>
            </el-form-item>
          </el-col>
          <el-col v-show="false" :xs="24">
            <el-form-item :label="$t('alarmPushRule.isRepeat')">
              <el-radio v-model="AlarmRform.isRepeat" :label="true">{{
                $t("desc.yes")
              }}</el-radio>
              <el-radio v-model="AlarmRform.isRepeat" :label="false">{{
                $t("desc.no")
              }}</el-radio>
            </el-form-item>
          </el-col>
          <el-col v-show="AlarmRform.isPush" :xs="24">
            <el-form-item prop="cycleValue" :label="$t('alarmPushRule.cycleValue')">
              <el-input
                style="max-width: 130px"
                onkeyup="value = value.replace(/^0+(d)/,'$1')"
                v-model.number="AlarmRform.cycleValue"
              />
              <el-select
                v-model="AlarmRform.cycleUnit"
                :placeholder="$t('desc.select')"
                style="max-width: 130px"
              >
                <el-option value="hour" :label="$t('alarmPushRule.hour')"></el-option>
                <el-option value="day" :label="$t('alarmPushRule.day')"></el-option>
                <el-option value="week" :label="$t('alarmPushRule.week')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="AlarmRform.isPush" :xs="24">
            <el-form-item :label="$t('alarmPushRule.cycleCondition')">
              <el-select
                v-model="AlarmRform.cycleCondition"
                :placeholder="$t('desc.select')"
                style="width: 260px"
              >
                <el-option :label="$t('desc.none')" value=""></el-option>
                <el-option 
                  v-for="item in conditionArr"
                  :key="item.bnDictCode"
                  :label="item.bnDictName"
                  :value="item.bnDictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="AlarmRform.isPush" :xs="24">
            <el-form-item :label="$t('alarmPushRule.isAttachAlarmMsg')">
              <el-radio v-model="AlarmRform.isAttachAlarmMsg" :label="true">{{
                $t("desc.yes")
              }}</el-radio>
              <el-radio v-model="AlarmRform.isAttachAlarmMsg" :label="false">{{
                $t("desc.no")
              }}</el-radio>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item>
              <el-button type="success" @click="validSubmit">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="dialog = false">{{ $t("button.cancel") }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <AlarmPushBindDialog
      :dialogBind="dialogBind"
      :ruleId="ruleId"
      :loading="saveLoading"
      :gatherReturnIdList="gatherReturnIdList"
      :batchAddCcnArr="batchAddCcnArr"
      @dialogVisibleEvent="showBindDialog"
      @showGatherDialog="showGatherDialog"
      @showBatchAddDialog="showBatchAddDialog"
      @onSubBtn="editAlarmPushCcn"
    >
    </AlarmPushBindDialog>
    <AlarmPushGatherDialog
      :dialogAlarmPushGather="dialogGather"
      :ccnId="ccnId"
      :gatherReturnIdList="gatherReturnIdList"
      @dialogVisibleEvent="showGatherDialog"
      @onSubBtn="editGatherRel"
    >
    </AlarmPushGatherDialog>
    <AlarmPushBatchAddCcnDialog
      :dialogBatch="dialogBatch"
      :ccnTable="notSelccnTable"
      @dialogVisibleEvent="showBatchAddDialog"
      @onSubBtn="batchAddCcn"
    >

    </AlarmPushBatchAddCcnDialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import {
  getAlarmPushRules,
  createAlarmPushRules,
  updateAlarmPushRules,
  deleteAlarmPushRules,
  authOperationCheck,
  updateAlarmPushCcnRel,
  getAlarmPushRuleConditions
} from "../../api/api";
import { getItemFormLocalstorage } from "../../../utils/package-localstorage";
import AlarmPushBindDialog from "../../components/content/maintabber/AlarmPushBindDialog.vue";
import AlarmPushGatherDialog from "../../components/content/maintabber/AlarmPushGatherDialog.vue";
import AlarmPushBatchAddCcnDialog from "../../components/content/maintabber/AlarmPushBatchAddCcnDialog.vue";
export default {
  name: "index",
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  components: {
    AlarmPushBindDialog,
    AlarmPushGatherDialog,
    AlarmPushBatchAddCcnDialog
  },
  data() {
    return {
      rules: {
        ruleCode: [{ required: true, message: this.$t("tips.needed"), trigger: "blur" }],
        ruleName: [{ required: true, message: this.$t("tips.needed"), trigger: "blur" }],
        cycleCondition: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
        isPush:[{required: true, message: this.$t("tips.needed"), trigger: "blur"}]
      },

      curLanguage: "",
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      btn: "",
      dialog: false,
      loading: false,
      formselect: {
        keyword: "",
      },
      tableData1: [],
      AlarmRform: {
        ruleCode: "",
        ruleName: "",
        isPush: true,
        isRepeat: true,
        cycleValue: 0,
        cycleUnit: "hour",
        cycleCondition: "",
        isAttachAlarmMsg: true,
      },
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      loginUserName: "",
      title: "",
      isDisabledCode: false,
      conditionArr:[],
      //绑定ccn相关
      dialogBind: false,
      ruleId: "",
      dialogGather: false,
      dialogBatch: false,
      ccnId: "",
      gatherReturnIdList: {},
      saveLoading: false,
      notSelccnTable:[],
      batchAddCcnArr:[]
    };
  },

  created: function () {
    this.authOperation("AlarmPushRules");
    this.loginUserName = getItemFormLocalstorage("userName");
  },

  mounted() {
    this.curLanguage = localStorage.getItem("user_lang");
    this.getData();
    this.getAlarmPushRuleConditions();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
    },
    async getAlarmPushRuleConditions(){
      let res = await getAlarmPushRuleConditions();
      this.conditionArr = res.result;
    },
    reset() {
      this.formselect = {
        keyword: "",
      };
      this.getData();
    },
    //删除
    async delUser(e) {
      try {
        let res = await deleteAlarmPushRules(e);
        if (res.success) {
          this.$message.success(this.$t("tips.deleteSuccess"));
          this.getData();
        } else {
          this.$message.error(res.error.message);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },
    add() {
      this.btn = "add";
      this.isDisabledCode = false;
      this.title = this.$t("alarmPushRule.addRule");
      this.dialog = true;
      this.AlarmRform = {
        ruleCode: "",
        ruleName: "",
        isPush: true,
        isRepeat: true,
        cycleValue: "0",
        cycleUnit: "hour",
        cycleCondition: "",
        isAttachAlarmMsg: true,
      };
    },
    edit(e) {
      this.btn = "edit";
      this.isDisabledCode = true;
      this.title = this.$t("alarmPushRule.editRule");
      this.AlarmRform = e;
      this.dialog = true;
    },
    async getData(type = "normal") {
      this.loading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      var data = {
          skipCount: (this.pagination.current - 1) * 10,
        },
        that = this;
      data = { ...data, ...this.formselect };
      try {
        let res = await getAlarmPushRules(data);
        that.tableData1 = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
        this.loading = false;
      } catch (err) {
        this.$message.error(err.error.message);
        this.loading = false;
      }
    },
    reserCheckBox() {
      this.checked1 = true;
      this.checked2 = false;
      this.checked3 = false;
    },
    async validSubmit() {
      this.$refs["AlarmRform"].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          return false;
        }
      });
    },
    async onSubmit() {
      let data = JSON.parse(JSON.stringify(this.AlarmRform)),
        that = this;
      if (this.btn == "add") {
        delete data.id;
        try {
          let res = await createAlarmPushRules(data);
          if (res.success) {
            this.$message.success("success");
            this.dialog = false;
            this.reserCheckBox();
            this.getData();
          } else {
            this.$message.error(res.error.message);
          }
        } catch (err) {
          this.$message.error(err.error.message);
        }
      } else {
        try {
          let res = await updateAlarmPushRules(data);
          if (res.success) {
            this.$message.success("success");
            this.dialog = false;
            this.reserCheckBox();
            this.getData();
          } else {
            this.$message.error(res.error.message);
          }
        } catch (err) {
          this.$message.error(err.error.message);
        }
      }
    },
    showBindDialog(visible, id) {
      if (visible) {
        this.ruleId = id;
      } else {
        this.gatherReturnIdList = new Object();
      }
      this.dialogBind = visible;
    },
    showGatherDialog(visible, row) {
      if (visible) {
        this.ccnId = row.ccnId;
        this.$set(this.gatherReturnIdList, row.ccnId, JSON.parse(row.alarmInfo));
      } else {
      }
      this.dialogGather = visible;
    },
    showBatchAddDialog(visible, notSelccnTable){
      this.dialogBatch = visible;
      this.notSelccnTable = notSelccnTable;
    },
    batchAddCcn(data){
      this.batchAddCcnArr = data;
      this.dialogBatch = false;
    },
    editGatherRel(idList, ccnId) {
      this.$set(this.gatherReturnIdList, ccnId, idList);
      this.dialogGather = false;
    },
    async editAlarmPushCcn(data) {
      this.saveLoading = true;
      let postdata = {
        RuleId: this.ruleId,
        AlarmCcnList: new Array(),
      };
      data.forEach((element) => {
        let obj = {
          CcnId: element.ccnId,
          RangeType: element.rangeType,
          BrandCode: localStorage.getItem("user_brand")
            ? localStorage.getItem("user_brand")
            : "IR",
          CcnGatherReturnIdList: JSON.parse(element.alarmInfo),
        };
        if (this.gatherReturnIdList[element.ccnId]) {
          obj.CcnGatherReturnIdList = this.gatherReturnIdList[element.ccnId];
        }
        postdata.AlarmCcnList.push(obj);
      });
      await updateAlarmPushCcnRel(postdata);
      this.saveLoading = false;
      this.$message.success(this.$t("tips.saveSuccess"));
      this.dialogBind = false;
    },
  },
};
</script>
